<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div class="card-title d-flex justify-content-start align-items-center">
          <button
            type="button"
            class="btn btn-icon btn-outline-primary"
            rippleEffect
            (click)="Back()"
          >
            <span [data-feather]="'arrow-left'"></span>
          </button>
          <h4 class="ml-50">Atrás</h4>
        </div>
      </div>
      <div class="card p-2" *ngIf="!isGeneratingMode">
        <div class="row">
          <div
            class="form group col-md-4 d-flex justify-content-between align-items-center m-1"
          >
            <label class="d-flex align-items-center"
              >Mostrando
              <select
                class="form-control mx-25"
                [(ngModel)]="basicSelectedOption"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option
                  *ngIf="assigments.length > 15"
                  [value]="assigments.length"
                >
                  Todos
                </option>
              </select>
              facturas</label
            >
          </div>
          <div
              class="form-group col-md-2 d-flex justify-content-center align-items-center"
            >
              <button
                class="btn btn-primary btn-prev mt-2"
                rippleEffect
                (click)="SearchAssigments()"
                [disabled]="searchForm.invalid"
              >
                <!--<i data-feather="search" class="align-middle mr-sm-25 mr-0"></i>-->
                <span class="align-middle d-sm-inline-block d-none"
                  >Buscar</span
                >
              </button>
            </div>
            <div
              class="form-group col-md-2 d-flex justify-content-center align-items-center"
            >
              <button
                class="btn btn-success btn-prev mt-2"
                rippleEffect
                (click)="generatePDF()"
                [disabled]="assigments.length === 0"
              >
                <!--<i
                  data-feather="printer"
                  class="align-middle mr-sm-25 mr-0"
                ></i>-->
                <span class="align-middle d-sm-inline-block d-none"
                  >Imprimir</span
                >
              </button>
            </div>
            <div
              class="form-group col-md-2 d-flex justify-content-center align-items-center"
            >
              <button
                class="btn btn-info btn-prev mt-2"
                rippleEffect
                (click)="GenerateBalance()"
                [disabled]="assigments.length === 0 || ValidateBillState()"
              >
                <!--<i data-feather="book" class="align-middle mr-sm-25 mr-0"></i>-->
                <span class="align-middle d-sm-inline-block d-none"
                  >Generar</span
                >
              </button>
            </div>
        </div>
        <form [formGroup]="searchForm">
          <div class="row">
            <div class="form-group col-md-3">
              <label class="form-label" for="vertical-language">
                <b class="text-primary">*</b> Envíos
              </label>
              <ng-select
                [items]="shippings"
                bindLabel="code"
                bindValue="id"
                formControlName="shippingId"
                (change)="GetFlightByShippingId()"
              >
              </ng-select>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="select-flights">
                Vuelos:
              </label>
              <ng-select                
                [items]="flights"
                bindLabel="code"
                bindValue="id"                
                formControlName="flightId"
                notFoundText="No hay vuelos"
              >
              </ng-select>
            </div>
            <div class="form-group col-md-3">
              <label class="form-label" for="vertical-language">
                <b class="text-primary">*</b> Repartidores
              </label>
              <ng-select
                [items]="dealers"
                bindLabel="userName"
                bindValue="id"
                formControlName="dealerId"
              >
              </ng-select>
            </div>
            
          </div>
        </form>
        <div #tablePrint ind="tablePrint" class="row">
          <div class="col-12">
            <ngx-datatable
              [rows]="assigments"
              [rowHeight]="58"
              class="bootstrap core-bootstrap"
              [columnMode]="ColumnMode.force"
              [headerHeight]="40"
              [footerHeight]="50"
              [scrollbarH]="true"
              [limit]="basicSelectedOption"
              [summaryRow]="true"
              [summaryPosition]="'bottom'"
              [messages]="{
                emptyMessage: 'No hay información para mostrar',
                totalMessage: 'Total de facturas'
              }"
            >
              <ngx-datatable-column
                name="Código"
                prop="billId"
                [summaryTemplate]="codeSummaryCell"
              >
                <ng-template let-billId="value" ngx-datatable-cell-template>
                  <!--<a [href]="GetURLById(id)" target="_blank">
                    {{ GetCodeById(id) }}</a
                  >-->
                  <a (click)="DownloadPdf(billId)" target="_self" placement="right"
                  ngbTooltip="Descargar pdf">
                    {{ GetCodeById(billId) }}</a
                  >
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Peso(Lbs)"
                prop="billPounds"
                [summaryTemplate]="poundsSummaryCell"
              >
                <ng-template let-billPounds="value" ngx-datatable-cell-template>
                  {{ billPounds }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Precio x Libra"
                prop="price"
                [summaryTemplate]="totalSummaryCell"
              >
                <ng-template let-billTotal="value" ngx-datatable-cell-template>
                  {{ billTotal | currency }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column
                name="Comisión"
                prop="total"
                [summaryTemplate]="dealertotalSummaryCell"
              >
                <ng-template let-total="value" ngx-datatable-cell-template>
                  {{ total | currency }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Moneda" prop="currencyName">
                <ng-template
                  let-currencyName="value"
                  ngx-datatable-cell-template
                >
                  {{ currencyName }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Estado" prop="billStateCatalogName">
                <ng-template
                  let-billStateCatalogName="value"
                  ngx-datatable-cell-template
                >
                  <div class="badge badge-primary">
                    {{ billStateCatalogName }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <ng-template #codeSummaryCell>
              <div class="name-container">
                <div class="chip"></div>
              </div>
            </ng-template>
            <ng-template #poundsSummaryCell>
              <div class="name-container">
                <div class="chip">
                  <span class="chip-content">{{
                    SummaryPounds() | number : "1.2-2"
                  }}</span>
                </div>
              </div>
            </ng-template>
            <ng-template #totalSummaryCell>
              <div class="name-container">
                <div class="chip">
                  <span class="chip-content">{{
                    SummaryTotal() | currency
                  }}</span>
                </div>
              </div>
            </ng-template>
            <ng-template #dealertotalSummaryCell>
              <div class="name-container">
                <div class="chip">
                  <span class="chip-content">{{
                    SummaryDealerTotal() | currency
                  }}</span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="card p-2" *ngIf="isGeneratingMode">
        <div class="row">
          <div class="col-4">
            <h3 class="text-center">
              <b>Repartidor: </b>{{ createDealerBalance?.dealerName }}
            </h3>
          </div>
          <div class="col-4">
            <h3 class="text-center">
              <b>Envío: </b>{{ createDealerBalance?.shippingCode }}
            </h3>
          </div>
          <div class="col-4">
            <h3 class="text-center">
              <b>Fecha: </b>{{ today | date : "dd/MM/yyyy" }}
            </h3>
          </div>
          <div class="col-12">
            <div class="divider">
              <div class="divider-text">Facturas</div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-3 text-center fw-bold">FACTURA</div>
              <div class="col-2 text-center fw-bold">PESO(LBS)</div>
              <div class="col-2 text-center fw-bold">PRECIO X LBS</div>
              <div class="col-3 text-center fw-bold">COMISIÓN</div>
              <div class="col-2 text-center fw-bold">MONEDA</div>
              <ng-container *ngFor="let assignment of assigments">
                <div class="col-3 text-center">{{ assignment?.billCode }}</div>
                <div class="col-2 text-center">
                  {{ assignment?.billPounds }}
                </div>
                <div class="col-2 text-center">
                  {{ assignment?.price | currency }}
                </div>
                <div class="col-3 text-center">
                  {{ assignment?.total | currency }}
                </div>
                <div class="col-2 text-center">
                  {{ assignment?.currencyName }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-12">
            <div class="divider">
              <div class="divider-text">Resumen de las Facturas</div>
            </div>
          </div>
          <div class="col-6">
            <b>Total de Facturas: </b>{{ createDealerBalance?.billsTotal }}
          </div>
          <div class="col-6 text-right">
            <b>Total Libras: </b>{{ totalPound }}
          </div>
          <div class="col-12">
            <div class="divider">
              <div class="divider-text">Resumen del Repartidor</div>
            </div>
          </div>
          <ng-container *ngFor="let resumen of currenciesResumen">
            <div class="col-3">
              <b>{{ resumen?.currencyName }}: </b
              >{{ resumen?.currencyTotal | currency }}
            </div>
          </ng-container>
          <div class="col-12 d-flex justify-content-end">
            <button
              class="btn btn-primary btn-prev mt-2 mr-2"
              rippleEffect
              (click)="AddBalance()"
            >
              <span class="align-middle d-sm-inline-block d-none">Generar</span>
            </button>
            <button class="btn btn-danger btn-prev mt-2" rippleEffect>
              <span
                class="align-middle d-sm-inline-block d-none"
                (click)="isGeneratingMode = false"
                >Cancelar</span
              >
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
